export const REGISTER_SIMPLE_REQUEST = 'register/REGISTER_SIMPLE_REQUEST';
export const REGISTER_SIMPLE_SUCCESS = 'register/REGISTER_SIMPLE_SUCCESS';
export const REGISTER_SIMPLE_FAILURE = 'register/REGISTER_SIMPLE_FAILURE';

export const SET_DEMO_REQUEST = 'registerexecutor/SET_DEMO_REQUEST';
export const SET_DEMO_SUCCESS = 'registerexecutor/SET_DEMO_SUCCESS';
export const SET_DEMO_FAILURE = 'registerexecutor/SET_DEMO_FAILURE';